<template>
  <b-modal
    v-model="showModal"
    title="Criar Novo Servico"
    ok-title="Criar Servico"
    cancel-title="Cancelar"
    modal-class="modal-success"
    centered
    :ok-disabled="!formularioValido || criando"
    :cancel-disabled="criando"
    :no-close-on-backdrop="criando"
    :no-close-on-esc="criando"
    :hide-header-close="criando"
    @ok="criarServico"
    @cancel="cancelar"
    @hidden="resetForm"
  >
    <div
      v-if="criando"
      class="text-center py-3"
    >
      <b-spinner
        variant="primary"
        class="mb-2"
      />
      <p class="mb-0">
        Criando servico, aguarde...
      </p>
      <small class="text-muted">
        Isto pode levar alguns segundos
      </small>
    </div>

    <div v-else>
      <b-form-group label="Nome do Servico">
        <b-form-input
          v-model="form.nome"
          placeholder="Digite o nome do servico"
          :state="tentouSalvar ? (form.nome.length > 0 ? true : false) : null"
          required
        />
        <b-form-invalid-feedback :state="form.nome.length > 0">
          O nome do servico e obrigatorio
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Valor">
        <b-form-input
          v-model.number="form.valorAuditar"
          type="number"
          step="0.01"
          min="0"
          placeholder="0,00"
          :state="tentouSalvar ? (form.valorAuditar >= 0 ? true : false) : null"
          required
        />
        <b-form-invalid-feedback :state="form.valorAuditar >= 0">
          O Valor Total é obrigatório
        </b-form-invalid-feedback>
      </b-form-group>

      <small
        v-if="mensagem"
        :class="mensagemTipo === 'success' ? 'text-success' : 'text-danger'"
        class="d-block mt-2"
      >
        {{ mensagem }}
      </small>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BSpinner,
} from 'bootstrap-vue'
import servicoApi from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'ServicoQuickCreate',
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BSpinner,
  },
  data() {
    return {
      showModal: false,
      tentouSalvar: false,
      criando: false,
      mensagem: '',
      mensagemTipo: '',
      form: {
        nome: '',
        valorAuditar: 0,
      },
    }
  },
  computed: {
    formularioValido() {
      return this.form.nome.trim().length > 0 && this.form.valorAuditar >= 0
    },
  },
  methods: {
    abrir(nome = '') {
      this.form.nome = typeof nome === 'string' ? nome : ''
      this.showModal = true
    },

    async criarServico(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.tentouSalvar = true

      if (!this.formularioValido) {
        this.setMensagem('Preencha todos os campos obrigatorios', 'danger')
        return
      }

      this.criando = true
      this.limparMensagem()

      const nomeSalvo = this.form.nome.trim()
      const valorAuditarSalvo = this.form.valorAuditar

      try {
        const payload = {
          nome: nomeSalvo,
          departamento: null,
          periodicidade: 'recorrente',
          valorRCC: 0,
          valorAuditar: valorAuditarSalvo,
          ativo: true,
          participaRodizioEquipe: false,
          osConstituicao: false,
          integrarManualOmie: false,
          matriz: false,
          honorarioContabil: false,
          substituirItens: false,
          tributacoes: [],
          atividades: [],
          tiposDocumentoLicenca: [],
          descricao: '',
        }

        const response = await servicoApi.createServico(payload)

        const retorno = response ? response.data : null
        let servicoFinal = retorno && typeof retorno === 'object' && retorno.id ? retorno : null
        const idCriado = typeof retorno === 'number' ? retorno : retorno?.id

        if (!servicoFinal && idCriado) {
          const detalhe = await servicoApi.getServico(idCriado)
          servicoFinal = detalhe.data
        }

        if (!servicoFinal) {
          servicoFinal = await this.localizarServicoCriado(nomeSalvo)
        }

        const servicoEmitido = servicoFinal || {
          id: idCriado || null,
          nome: nomeSalvo,
          departamento: null,
          atividades: [],
          tributacoes: [],
          tiposDocumentoLicenca: [],
          valorAuditar: valorAuditarSalvo,
          valorRCC: 0,
          honorarioContabil: false,
        }

        this.$emit('servico-criado', servicoEmitido)

        if (this.$sucesso) {
          this.$sucesso('Servico criado com sucesso!')
        }

        this.showModal = false
        this.resetForm()
      } catch (error) {
        this.setMensagem(error.response?.data?.message || 'Erro ao criar servico. Tente novamente.', 'danger')
      } finally {
        this.criando = false
      }
    },

    cancelar() {
      this.resetForm()
    },

    resetForm() {
      this.form.nome = ''
      this.form.valorAuditar = 0
      this.tentouSalvar = false
      this.limparMensagem()
    },

    setMensagem(texto, tipo) {
      this.mensagem = texto
      this.mensagemTipo = tipo
    },

    limparMensagem() {
      this.mensagem = ''
      this.mensagemTipo = ''
    },
    async localizarServicoCriado(nome) {
      const nomeNormalizado = (nome || '').trim().toLowerCase()
      if (!nomeNormalizado) return null

      const filtros = [
        {
          coluna: 'Nome',
          valor: nome,
        },
      ]

      const tentativasMaximas = 2
      const intervaloMs = 1500

      const executarBusca = async tentativa => {
        try {
          const resposta = await servicoApi.getServicosResumidos(filtros, Date.now())
          const lista = Array.isArray(resposta?.data) ? resposta.data : []

          const encontrados = lista.filter(item => {
            const nomeItem = (item?.nome || '').trim().toLowerCase()
            return nomeItem === nomeNormalizado
          })

          if (encontrados.length > 0) {
            encontrados.sort((a, b) => {
              const dataA = new Date(a?.dataCadastro || a?.dataAtualizacao || 0)
              const dataB = new Date(b?.dataCadastro || b?.dataAtualizacao || 0)
              return dataB - dataA
            })
            return encontrados[0]
          }
        } catch (error) {
          // Ignora erros de busca e continua tentando
        }

        if (tentativa >= tentativasMaximas) {
          return null
        }

        await new Promise(resolve => setTimeout(resolve, intervaloMs))
        return executarBusca(tentativa + 1)
      }

      return executarBusca(1)
    },
  },
}
</script>
